//Prepends value with text passed as argument
//Example: "01/01/2018" with argument "as of" returns "as of 01/01/2018"
export default function prependStr(value, prependText) {
	return value ? `${prependText} ${value}` : "";
}
